import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Loadable from "@loadable/component"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const OwlCarousel = Loadable(() => import("react-owl-carousel3"))

const options = {
  loop: true,
  nav: true,
  dots: true,
  autoplayHoverPause: true,
  autoplay: true,
  items: 1,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
}

const query = graphql`
  {
    allStrapiHeropageSlider {
      edges {
        node {
          title
          subtitle1
          subtitle2
          img {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        }
      }
    }
  }
`

const renderHeroSlide = (hero, index) => {
  const image = getImage(hero.node.img.localFile)
  return (
    <div key={index} className="main-banner-item">
      <GatsbyImage
        image={image}
        className="main-banner-bg-image"
        style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, zIndex: -1 }}
        alt=""
        loading={index === 0 ? "eager" : "lazy"}
      />
      <div className="d-table">
        <div className="d-table-cell">
          <div className="container">
            <div className="banner-item-content">
              <h1>{hero.node.title ? hero.node.title : ""}</h1>
              <p>{hero.node.subtitle1 ? hero.node.subtitle1 : ""}</p>
              <div className="btn-box"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const MainBanner = () => {
  const [display, setDisplay] = React.useState(false)

  React.useEffect(() => {
    setDisplay(true)
  }, [])

  const data = useStaticQuery(query)
  const heros = data.allStrapiHeropageSlider.edges
  const firstHero = heros?.[0]

  return (
    <React.Fragment>
      {display ? (
        <OwlCarousel
          className="home-slides owl-carousel owl-theme"
          {...options}
        >
          {heros.map(renderHeroSlide)}
        </OwlCarousel>
      ) : firstHero ? (
        <div className="home-slides owl-carousel owl-theme hero-carousel-placeholder">
          {renderHeroSlide(firstHero, 0)}
        </div>
      ) : null}
    </React.Fragment>
  )
}

export default MainBanner
